import { PRIVACY_URL, TERMS_URL } from "@/lib/legal-links";
import { useT } from "@/i18n";
import { authMessages } from "@/i18n/messages/auth";

const NOTICE_KEY = {
  create: "termsCreate",
  continue: "termsContinue",
  download: "termsDownload",
} as const satisfies Record<string, keyof typeof authMessages.en>;

/**
 * Terms consent shown next to the buttons that create an account or
 * download the desktop app. The backend records acceptance on sign-up
 * because this line is always shown there.
 * Auth pages run in a real browser, so the links open a new tab.
 */
export function AuthTermsNotice({
  action,
  tabIndex,
}: {
  action: keyof typeof NOTICE_KEY;
  tabIndex?: number;
}) {
  const t = useT(authMessages);
  return (
    <p
      className="max-w-[330px] text-appkit-caption leading-[1.45] text-[color:var(--auth-ink-secondary)]"
      data-testid="auth-terms-notice"
    >
      {t.rich(NOTICE_KEY[action], {
        terms: (chunks) => (
          <a
            href={TERMS_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="auth-inline-link"
            data-testid="auth-terms-link"
            tabIndex={tabIndex}
          >
            {chunks}
          </a>
        ),
        privacy: (chunks) => (
          <a
            href={PRIVACY_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="auth-inline-link"
            data-testid="auth-privacy-link"
            tabIndex={tabIndex}
          >
            {chunks}
          </a>
        ),
      })}
    </p>
  );
}
